import fetchJsonp from 'fetch-jsonp';
import { HttpResponseError, SourceBase } from './SourceBase';
import type { AjaxSourceOptions } from './Sources.types';

export abstract class AjaxSource<T extends AjaxSourceOptions = AjaxSourceOptions> extends SourceBase<T> {
    getAjaxPromise(url?: string): Promise<unknown> {
        return (this.options.jsonp ? fetchJsonp : fetch)(url || this.options.url).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new HttpResponseError(`Request failed with HTTP ${response.status}`);
        });
    }
}
